import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
})
export class DeclarationComponent  {
 id;
 orderId;
 purchaseItems;
 love:boolean = false;
 orderItems;
 check;
 loader:boolean =false;
 constructor(private service: ApiService,
  public auth: AuthService,
  public handler: HandlerService,
  public location: LocationService,
  public router: Router
 ) { }

 ionViewWillEnter(){
  this.orderId = localStorage.getItem('orderId')
  this.service.getOrderById(this.orderId).subscribe((res:any) => {
    this.purchaseItems = res;
  })
 }
 route(id){
   this.loader =true;
   Object.assign(this.purchaseItems,{
    "id": this.orderId,
    "check": true,"cnvcChargeApplied":true
   })
   this.service.updateOrder(this.orderId,this.purchaseItems).subscribe((res:any) =>{
    this.router.navigate(['invoice/', +this.orderId]);
    this.loader = false;
  },err => {
    this.loader = false;
    this.handler.err(err)
  })
 
}
}
